import _ from "lodash";
import { adam } from "./adam";
import { integrityMocks } from "./integrity";
import { campaignMocks } from "./campaign";
import { ticketMocks } from "./ticket";
import { manageMocks } from "./manage";
import { customersMocks } from "./customers";
import { communityAnalysisMocks } from "./communityAnalysis";
import { ecoScanMocks } from "./ecoscan";

export const handlers = [
  ...integrityMocks,
  ...campaignMocks,
  ...adam,
  ...ticketMocks,
  ...manageMocks,
  ...customersMocks,
  ...communityAnalysisMocks,
  ...ecoScanMocks,
];
